/**
 * Grupos del estado de resultado (ORR-144).
 *
 * Cada categoría de gasto (la "etiqueta": publicidad, sueldos, software…) se clasifica
 * en uno de estos 4 grupos contables. El gasto hereda el grupo de su categoría.
 * `null` = sin clasificar (aparece aparte en el reporte hasta que se le asigne grupo).
 */
export const GRUPOS_RESULTADO = ['operativo', 'comercial', 'administrativo', 'financiero'] as const

export type GrupoResultado = (typeof GRUPOS_RESULTADO)[number]

export const GRUPO_RESULTADO_LABEL: Record<GrupoResultado, string> = {
  operativo: 'Operativo',
  comercial: 'Comercial',
  administrativo: 'Administrativo',
  financiero: 'Financiero',
}

/** Texto de ayuda por grupo (basado en el Excel de Lisandro). */
export const GRUPO_RESULTADO_DESC: Record<GrupoResultado, string> = {
  operativo: 'Directos al servicio (sueldos, software)',
  comercial: 'Para generar ventas (transporte, comida, impuestos)',
  administrativo: 'Estructura (alquiler, empleados, publicidad, honorarios)',
  financiero: 'Intereses y comisiones bancarias',
}
